// App.js
import "./App.css";
import Header from "./components/header.jsx";
import Footer from "./components/footer.jsx";
import { Routes, Route } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet-async";

// Pages
import Home from "./Pages/Home.jsx"; // renamed from Banner.jsx
import About from "./Pages/About.jsx";
import ServicesPage from "./Pages/ServicesPage.jsx";

// Example placeholder pages (replace with your real components)

const Blog = () => <div>Blog</div>;
const Contact = () => <div>Contact Us</div>;

function App() {
  return (
    <>
      <Helmet>
        <title>Handyman Services | Repairs, Maintenance & Improvements</title>
        <meta
          name="description"
          content="Reliable handyman services for home repairs, maintenance and improvements. Trusted professionals for your property."
        />
        <link rel="canonical" href="https://websolutionusa.com/templates/handyman/" />
        <meta
          property="og:title"
          content="Handyman Services – Repairs, Maintenance & Improvements"
        />
        <meta
          property="og:description"
          content="Get top-quality handyman services from skilled professionals—fixing, maintaining and improving your home with ease."
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
